module.exports = __webpack_public_path__ + "img/invoice-de-female-nw.3299e952.png";